import { SVGProps, Ref, forwardRef } from 'react';

export const SuperstarOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M16.111 10.035a14 14 0 0 1 1.845.544q.042.7.044 1.421c0 6.627-2.686 12-6 12-1.93 0-3.645-1.822-4.742-4.651q1.02.201 2.1.314l.01.018c.99 1.98 2.024 2.52 2.632 2.52s1.643-.54 2.633-2.52C15.569 17.808 16.2 15.095 16.2 12q-.002-1.013-.089-1.965"
                fill="currentColor"
            />
            <path
                d="M4.65 7.259a23 23 0 0 0-.314 2.1l-.017.008C2.34 10.357 1.8 11.392 1.8 12s.54 1.643 2.52 2.633C6.192 15.569 8.905 16.2 12 16.2q1.012-.002 1.964-.089a14 14 0 0 1-.544 1.845q-.7.042-1.42.044c-6.627 0-12-2.686-12-6l.004-.155c.095-1.866 1.893-3.518 4.645-4.586"
                fill="currentColor"
            />
            <path
                d="M12.617 6.008C18.957 6.168 24 8.79 24 12l-.004.155c-.095 1.866-1.894 3.518-4.647 4.586q.201-1.018.314-2.1l.018-.008c1.98-.99 2.52-2.025 2.52-2.633s-.54-1.643-2.52-2.633C17.808 8.431 15.095 7.8 12 7.8q-1.013.001-1.965.088c.152-.676.336-1.295.544-1.845Q11.28 6 12 6z"
                fill="currentColor"
            />
            <path
                d="M12 9.5c.303 0 .482.43.839 1.287l.11.263.264.11c.858.358 1.287.537 1.287.84s-.43.482-1.287.839l-.265.11-.11.264c-.356.858-.535 1.287-.838 1.287s-.482-.43-.84-1.287l-.11-.265-.263-.11C9.93 12.483 9.5 12.304 9.5 12s.43-.482 1.287-.84l.264-.11.11-.263c.357-.858.536-1.287.839-1.287"
                fill="currentColor"
            />
            <path
                d="M12 0c1.929 0 3.643 1.821 4.74 4.65a23 23 0 0 0-2.1-.314l-.007-.017C13.643 2.34 12.608 1.8 12 1.8s-1.643.54-2.633 2.52C8.431 6.192 7.8 8.905 7.8 12q.001 1.012.088 1.964a14 14 0 0 1-1.845-.544Q6.001 12.72 6 12C6 5.373 8.686 0 12 0"
                fill="currentColor"
            />
        </g>
    </svg>
));
SuperstarOutlinedSize24Glyph.displayName = 'SuperstarOutlinedSize24Glyph';
